<!-- apps/frontend/src/components/flow/WebhookFlowNodePalette.vue -->
<template>
  <aside class="absolute top-0 right-0 h-full w-72 bg-gray-800 border-l border-gray-700 z-10 flex flex-col shadow-xl" @click.stop>
    <div class="flex justify-between items-center p-4 border-b border-gray-700 shrink-0">
      <h2 class="text-base font-semibold text-white">{{ $t('flowEditor.nodePalette.title') }}</h2>
      <button @click="emit('close')" class="text-gray-400 hover:text-white">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="flex-1 overflow-y-auto p-3 flex flex-col gap-4">
      <div v-for="category in categories" :key="category.key">
        <p class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 px-1">{{ $t(`flowEditor.nodePalette.categories.${category.key}`) }}</p>
        <div class="flex flex-col gap-1">
          <button
            v-for="node in category.nodes" :key="node.type"
            class="flex items-start gap-3 p-3 rounded-lg bg-gray-700 hover:bg-violet-700 transition-colors text-left w-full"
            @click="emit('select', node.type)"
          >
            <span class="material-icons text-violet-400 mt-0.5 text-base shrink-0">{{ node.icon }}</span>
            <div>
              <p class="text-sm font-medium text-white">{{ $t(`flowEditor.nodePalette.nodes.${node.type}.label`) }}</p>
              <p class="text-xs text-gray-400 mt-0.5 leading-snug">{{ $t(`flowEditor.nodePalette.nodes.${node.type}.description`) }}</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  </aside>
</template>
<script setup>
import { computed } from 'vue';
import { filterPaletteCategories } from '../../utils/flowPalette';

const props = defineProps({
  sourceNodeId: { type: String, required: false, default: null },
  whatsappActive: { type: Boolean, default: false },
});
const emit = defineEmits(['select', 'close']);

const BASE_CATEGORIES = [
  {
    key: 'flusso',
    nodes: [
      { type: 'webhookOutput', icon: 'stop_circle' },
    ],
  },
  {
    key: 'conversazione',
    nodes: [
      { type: 'sendMessage', icon: 'send' },
      { type: 'triggerAgent', icon: 'smart_toy' },
      { type: 'fetchHistory', icon: 'history' },
      { type: 'askAgent', icon: 'psychology_alt' },
      { type: 'activateTransfer', icon: 'alt_route' },
      { type: 'deactivateTransfer', icon: 'undo' },
    ],
  },
  {
    key: 'logica',
    nodes: [
      { type: 'ifCondition', icon: 'call_split' },
      { type: 'setVariable', icon: 'edit_note' },
      { type: 'executeCode', icon: 'code' },
      { type: 'addTags', icon: 'sell' },
    ],
  },
  {
    key: 'integrazioni',
    nodes: [
      { type: 'apiCall', icon: 'http' },
      { type: 'useMcpTool', icon: 'extension' },
    ],
  },
  {
    key: 'whatsapp',
    nodes: [
      { type: 'sendWhatsapp', icon: 'forum' },
      { type: 'sendWhatsappTemplate', icon: 'description' },
    ],
  },
];

const categories = computed(() => filterPaletteCategories(BASE_CATEGORIES, { whatsappActive: props.whatsappActive }));
</script>
